var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 79,
    viewBox: "0 0 44 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90224 76.3953L2.2461 72.9831C1.41941 72.4844 0.914062 71.5894 0.914062 70.6239L0.914062 23.4375C0.914062 21.9378 1.27612 20.6991 2.21347 19.9492L7.66296 23.0626L7.90224 76.3953Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91669 23.0628L1.77344 20.4828C2.22336 19.7329 2.6049 19.6883 3.1673 19.3134L33.5287 1.7074C34.3504 1.23088 35.3597 1.21126 36.1993 1.65549L41.4493 4.43308L6.91669 23.0628Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5488 4.31545L6.72656 22.8746L6.72656 74.8678C6.72656 75.8578 8.01117 76.2459 8.55931 75.4214L11.499 70.9998L14.999 72.4998L17.499 67.9998L20.999 69.4998L23.499 64.4998L26.499 65.9998L28.999 61.4998L31.999 62.9998L33.999 58.4998L36.999 59.9998L39.499 55.4998L42.5332 57.7439L42.5332 6.05641C42.5332 4.52477 40.8821 3.56157 39.5488 4.31545Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration.551d3d3412bd257e173ca924734cd767.svg";